import { createSelector } from "reselect";

/** @type {() => typeof import("./reducer").initState} */
export const selectRoot = (state) => state.billingAndInvoicing;

export const selectBill = createSelector(selectRoot, (state) => state.bill);
export const selectInvoice = createSelector(selectRoot, (state) => state.invoice);
export const selectInvoiceSettings = createSelector(selectRoot, (state) => state.invoiceSettings);
export const selectBillSettingList = createSelector(selectRoot, (state) => state.billSettingList);
export const selectBillSettingItem = createSelector(selectRoot, (state) => state.billSettingItem);
export const selectInvoiceRecipient = createSelector(selectRoot, (state) => state.invoiceRecipient);
export const selectInvoiceRecipientList = createSelector(selectRoot, (state) => state.invoiceRecipientList);
export const selectInvoiceList = createSelector(selectRoot, (state) => state.invoiceList);
export const selectBillList = createSelector(selectRoot, (state) => state.billList);
export const selectInvoiceSettingsList = createSelector(selectRoot, (state) => state.invoiceSettingsList);
